import React from 'react';
import propTypes from 'prop-types';
export const MoonIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 324.694 324.694"
      enableBackground="new 0 0 324.694 324.694"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M291.396,287.685c-0.646-3.021-3.045-5.356-6.077-5.925c-58.351-11.019-104.084-55.646-116.517-113.696
     c-12.433-58.06,11.013-117.502,59.735-151.451c2.531-1.761,3.759-4.876,3.115-7.894c-0.647-3.018-3.046-5.355-6.078-5.933
     c-21.053-3.976-42.939-3.691-64.052,0.824c-42.397,9.078-78.725,34.122-102.286,70.528
     c-23.559,36.397-31.535,79.792-22.454,122.189c15.926,74.377,82.62,128.361,158.579,128.367c0.004,0,0.013,0,0.017,0
     c11.396,0,22.88-1.221,34.129-3.625c21.267-4.554,41.042-13.129,58.772-25.484C290.816,293.817,292.04,290.701,291.396,287.685z
      M226.294,306.07c-10.197,2.18-20.597,3.288-30.916,3.288c-0.004,0-0.007,0-0.013,0c-68.777-0.008-129.161-48.891-143.581-116.244
     c-8.224-38.391-1.004-77.68,20.33-110.642c21.333-32.96,54.227-55.646,92.621-63.861c10.181-2.187,20.58-3.288,30.9-3.288
     c3.119,0,6.245,0.097,9.365,0.299c-43.655,38.534-63.604,97.721-51.202,155.652c12.41,57.93,54.851,103.759,110.463,121.029
     C252.376,298.597,239.663,303.209,226.294,306.07z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
MoonIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
MoonIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
